import numeral from 'numeral';
// import { linReg } from '../../lib/reduce';

import { Cell } from '@table-library/react-table-library/table';

export const COLUMNS = (default_image, t) => [
    {
        label: t('discover.category.category_table.page'),
        key: 'page',
        data: 'page',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            let title = item.title;

            if (!item.title) {
                title = item.page;
            }
            if (csvDownload) return title;
            return (
                <div>
                    <div className="d-flex align-items-center">
                        <div style={{ display: 'contents' }}>
                            <img
                                onError={(event) => (event.target.src = default_image)}
                                src={item.image ?? default_image}
                                style={{
                                    background: '#BBB',
                                    width: '70px',
                                    borderRadius: '8px',
                                    objectFit: 'cover',
                                }}
                                alt="page_image"
                                loading="lazy"
                            />
                        </div>
                        <div style={{ marginLeft: '8px' }}>
                            <strong>
                                <a
                                    href={
                                        `/domains/${window.info.id}/pages/page?page=` +
                                        encodeURIComponent(item.page)
                                    }
                                >
                                    {title}
                                </a>
                                <a
                                    target="_blank"
                                    className="link-website d-inline-flex align-items-center justify-content-center"
                                    href={item.page}
                                    rel="noreferrer"
                                >
                                    <i className="icon-external-link"></i>
                                </a>
                            </strong>
                        </div>
                    </div>
                </div>
            );
        },
    },
    {
        label: t('discover.category.category_table.age'),
        key: 'age',
        data: 'age',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col-1">
                    <strong>{numeral(data).format('0,00')} Days</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.category.category_table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col-1">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.category.category_table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col-1">
                    <strong>{numeral(data).format('0.0a')}</strong>
                </div>
            );
        },
    },
    {
        label: t('discover.category.category_table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <div className="col-1 align-center">
                    <strong>{numeral(data).format('0.00%')}</strong>{' '}
                </div>
            );
        },
    },
];

export const COLUMNS_EXPORT = (t) => [
    ...COLUMNS(null, t),
    {
        label: t('discover.category.category_table.url'),
        key: 'page',
        data: 'page',
        Component: Cell,
    },
];
